import GlobalFields from 'defs/ga/fields/global';
import { MySuccessOpen } from '../fields/mySuccess';

export const trackMySuccessAccess = ({
	coachProgAction,
	coachLanguage,
	coachLevelStatus,
	coachLevelPoints,
}: {
	coachProgAction: string;
	coachLanguage: string;
	coachLevelStatus: string;
	coachLevelPoints: string;
}): Object => ({
	[GlobalFields.Event]: 'coach_programm',
	[MySuccessOpen.Action]: coachProgAction,
	[MySuccessOpen.Language]: coachLanguage,
	[MySuccessOpen.LevelStatus]: coachLevelStatus,
	[MySuccessOpen.LevelPoints]: coachLevelPoints,
});
